import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NgForm,
  Validator,
} from '@angular/forms';

import {
  BrowserService,
} from 'webcommon/legacy-common';

import { ApRequiredBase } from './ap-required-base';

@Directive({
  providers: [{ provide: NG_VALIDATORS, useExisting: ApRequiredDirective, multi: true }],
  selector: '[apRequired]',
})
export class ApRequiredDirective extends ApRequiredBase implements Validator {
  constructor(
    browserService: BrowserService,
    elementRef: ElementRef,
    ngForm: NgForm,
    renderer: Renderer2,
  ) {
    super(browserService, elementRef, ngForm, renderer);
  }

  private innerIsRequired: boolean;
  get isRequired(): boolean {
    return this.innerIsRequired;
  }
  @Input('apRequired') set isRequired(value: boolean) {
    this.innerIsRequired = value;
    super.onRequiredChanged();
  }

  @Input() showRequiredOnly = false;

  protected getIsRequired() {
    return this.isRequired;
  }

  protected isShowRequriedOnly() {
    return this.showRequiredOnly;
  }
}
